import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AppDeployment, CompatibleProductId } from '@atlassian/mpac-types';
import { AtlassianProductHostingType, MarketplaceAppPaymentModel } from '@atlassian/mpac-types/graphql-gateway-types';
import { MarketplaceAppUtils } from '@atlassian/mpac-utils';
import { FREE_APP_CTA_LABEL_SECONDARY, TEST_ID } from '../../../constants';
import { CTAKind, PurchaseIntent } from '../AppListing.types';
import { MoreActionsCTA } from '../MoreActionsCTA';
import { CTAContainer } from './AppListingCTA.styles';
import { BitbucketCTA, getArtifactOrLearnMoreCTAs, getGenericCloudCTAs, PrivateListingCTA, UnsupportedPrimaryCTA } from './AppListingCTACollection';
import { getServerDCCTAs } from './ServerDCCTA';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line complexity, max-lines-per-function
export function getAppListingCTAs(ctaProps) {
  const {
    appId,
    appKey,
    appVersion,
    privateRemotableOnly,
    selectedHosting,
    onClick: _onClick,
    trialLicenseActivationLink,
    licensePurchaseLink,
    privateListingsLink,
    artifactDownloadLink
  } = ctaProps;
  const primaryPurchaseIntent = appVersion.paymentModel === MarketplaceAppPaymentModel.Free ? PurchaseIntent.GET : PurchaseIntent.TRY;
  const hasBitbucketCompatibleProduct = appVersion.deployment.compatibleProducts.some(product => product.id === CompatibleProductId.Bitbucket);

  /**
   * Project Care Bear (Server EOL).
   * Server apps, except for those supporting fisheye/crucible, bamboo and crowd
   * are no longer available for sale via Marketplace.
   */
  const showServerEol = selectedHosting === AtlassianProductHostingType.Server && !MarketplaceAppUtils.isExcludedServerApp(appVersion.deployment.compatibleProducts);
  switch (true) {
    case showServerEol:
      return {
        PrimaryCTA: null,
        SecondaryCTA: null
      };
    case privateRemotableOnly && !!privateListingsLink:
      return {
        PrimaryCTA(ctaOverrides) {
          return /*#__PURE__*/_jsx(PrivateListingCTA, _objectSpread({
            paymentModel: appVersion.paymentModel,
            appId: appId,
            privateListingsLink: privateListingsLink,
            onClick: e => _onClick(e, primaryPurchaseIntent, CTAKind.PRIMARY)
          }, ctaOverrides));
        }
      };
    case MarketplaceAppUtils.isNotAnApp(appVersion.deployment):
      {
        const hasBinaryArtifact = appVersion.deployment.__typename === AppDeployment.INSTRUCTIONAL ? appVersion.deployment.isBinaryUrlAvailable : appVersion.deployment.__typename === AppDeployment.WORKFLOW ? appVersion.deployment.isWorkflowDataFileAvailable : false;
        return getArtifactOrLearnMoreCTAs({
          binaryAvailable: hasBinaryArtifact,
          appId,
          onClick: _onClick,
          appVersion,
          artifactDownloadLink
        });
      }
    case MarketplaceAppUtils.isRemoteable(appVersion.deployment) && hasBitbucketCompatibleProduct:
      return {
        PrimaryCTA(ctaOverrides) {
          return /*#__PURE__*/_jsx(BitbucketCTA, _objectSpread({
            paymentModel: appVersion.paymentModel,
            appKey: appKey,
            onClick: e => _onClick(e, primaryPurchaseIntent, CTAKind.PRIMARY),
            ctaSubtext: appVersion.paymentModel === MarketplaceAppPaymentModel.Free ? FREE_APP_CTA_LABEL_SECONDARY : undefined
          }, ctaOverrides));
        },
        SecondaryCTA: null
      };
    case selectedHosting === AtlassianProductHostingType.Server || selectedHosting === AtlassianProductHostingType.DataCenter:
      return getServerDCCTAs({
        appId,
        appKey,
        onClick: _onClick,
        appVersion,
        artifactDownloadLink,
        trialLicenseActivationLink,
        licensePurchaseLink,
        hosting: selectedHosting
      });
    case selectedHosting === AtlassianProductHostingType.Cloud:
      return getGenericCloudCTAs({
        paymentModel: appVersion.paymentModel,
        onClick: e => _onClick(e, primaryPurchaseIntent, CTAKind.PRIMARY)
      });
    default:
      return {
        PrimaryCTA: UnsupportedPrimaryCTA
      };
  }
}
const AppListingCTA = props => {
  const {
    PrimaryCTA,
    SecondaryCTA
  } = getAppListingCTAs({
    appId: props.appId,
    appKey: props.appKey,
    appVersion: props.appVersion,
    privateRemotableOnly: props.privateRemotableOnly,
    selectedHosting: props.selectedHosting,
    onClick: props.onClick,
    trialLicenseActivationLink: props.trialLicenseActivationLink,
    licensePurchaseLink: props.licensePurchaseLink,
    privateListingsLink: props.privateListingsLink,
    artifactDownloadLink: props.artifactDownloadLink
  });
  let SecondaryCTASpaced;
  if (SecondaryCTA) {
    SecondaryCTASpaced = SecondaryCTA;
  } else {
    SecondaryCTASpaced = null;
  }
  return /*#__PURE__*/_jsxs(CTAContainer, {
    children: [PrimaryCTA && /*#__PURE__*/_jsx(PrimaryCTA, {
      testId: TEST_ID.CTA_INSTALL_APP_BTN,
      size: "large",
      shouldFitContainer: false
    }), SecondaryCTASpaced && /*#__PURE__*/_jsx(SecondaryCTASpaced, {
      appearance: "default",
      shouldFitContainer: false
    }), props.selectedHosting !== AtlassianProductHostingType.Server && /*#__PURE__*/_jsx(MoreActionsCTA, {
      watchersInfo: props.watchersInfo,
      appKey: props.appKey,
      loginHref: props.loginHref,
      isLoggedIn: props.isLoggedIn
    })]
  });
};
export default AppListingCTA;